module.exports = __webpack_public_path__ + "img/control-panel-dark-01.3788f8f0.jpg";